import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/homeData';

const articleImages: Record<string, string> = {
  'article-card-01': 'https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20a%20person%20hands%20typing%20on%20a%20silver%20laptop%20keyboard%20with%20a%20neatly%20organized%20spreadsheet%20visible%20on%20screen%20soft%20golden%20hour%20sunlight%20filtering%20through%20sheer%20curtains%20casting%20warm%20diagonal%20shadows%20across%20a%20light%20beige%20desk%20surface%20with%20a%20ceramic%20coffee%20mug%20beside%20the%20laptop%20editorial%20quality%20intimate%20warm%20atmosphere&width=800&height=500&seq=article-card-01-2026-v3&orientation=landscape',
  'article-card-02': 'https://readdy.ai/api/search-image?query=Top%20down%20view%20of%20a%20clean%20white%20desk%20with%20scattered%20product%20research%20materials%20a%20tablet%20showing%20colorful%20data%20charts%20color%20swatches%20fabric%20samples%20and%20a%20pair%20of%20reading%20glasses%20arranged%20geometrically%20soft%20diffused%20studio%20lighting%20minimal%20shadows%20editorial%20still%20life%20photography&width=800&height=500&seq=article-card-02-2026-v3&orientation=landscape',
  'article-card-03': 'https://readdy.ai/api/search-image?query=Warm%20lifestyle%20image%20of%20cardboard%20shipping%20boxes%20in%20various%20sizes%20stacked%20neatly%20beside%20a%20laptop%20on%20a%20light%20oak%20desk%20with%20a%20world%20map%20pinned%20to%20a%20corkboard%20in%20the%20blurred%20background%20morning%20light%20through%20a%20window%20casting%20long%20soft%20shadows%20cozy%20productive%20atmosphere&width=800&height=500&seq=article-card-03-2026-v3&orientation=landscape',
};

export default function ArticleCards() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          Latest Research Guides
        </h2>

        <div className="flex gap-6 overflow-x-auto pb-4 scroll-smooth">
          {articleCards.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="flex-shrink-0 w-[320px] md:w-[360px] rounded-2xl bg-background-100 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative">
                {article.isNew && (
                  <span className="absolute top-3 left-3 z-10 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label font-medium whitespace-nowrap">
                    NEW
                  </span>
                )}
                <div className="p-5">
                  <img
                    src={articleImages[article.imageSeq] || articleImages['article-card-01']}
                    alt={article.title}
                    className="w-full aspect-[1.6] object-cover rounded-xl bg-background-50"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="px-5 pb-6 text-center">
                <h3 className="text-foreground-950 text-lg font-label font-semibold mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm">{article.excerpt}</p>
                <span className="inline-block mt-3 text-xs text-foreground-400 font-label">
                  Read More →
                </span>
              </div>
            </Link>
          ))}
          <div className="flex-shrink-0 w-6"></div>
        </div>
      </div>
    </section>
  );
}